import React from 'react';
import {
  TOWER_TYPES,
  TOWER_TYPE_LABELS,
  TOWER_TYPE_COLORS,
  TOWER_TYPE_GLOW,
  TOWERS,
} from '../hooks/useRotationOrder';

// Positions on the map (% of container width/height)
const TOWER_POSITIONS = {
  1: { left: '61%', top: '72%' },
  2: { left: '37%', top: '72%' },
  3: { left: '61%', top: '55%' },
  4: { left: '37%', top: '55%' },
  5: { left: '57%', top: '37%' },
  6: { left: '41%', top: '37%' },
};

const TYPE_OPTIONS = Object.entries(TOWER_TYPE_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export default function TowerMap({ towerTypes, onChange, rotationOrder }) {
  const handleChange = (towerId, value) => {
    onChange({ ...towerTypes, [towerId]: value });
  };

  const getOrderIndex = (towerId) =>
    rotationOrder.findIndex((t) => t.id === towerId);

  return (
    <div className="map-wrapper">
      <div className="map-container">
        {/* Sector labels */}
        <div className="sector-label sector-d">Setor D ⭐</div>
        <div className="sector-label sector-b">Setor B</div>
        <div className="sector-label sector-c">Setor C</div>
        <div className="sector-label sector-a">Setor A</div>
        <div className="sector-label sector-1">Setor A</div>

        {/* Castle icon center top */}
        <div className="castle-icon">🏰</div>

        {/* Towers */}
        {TOWERS.map((tower) => {
          const type = towerTypes[tower.id] || '';
          const color = type ? TOWER_TYPE_COLORS[type] : '#555';
          const glow = type ? TOWER_TYPE_GLOW[type] : 'transparent';
          const orderIdx = getOrderIndex(tower.id);
          const orderLabel = orderIdx >= 0 ? orderIdx + 1 : null;

          return (
            <div
              key={tower.id}
              className="tower-node"
              style={{
                left: TOWER_POSITIONS[tower.id].left,
                top: TOWER_POSITIONS[tower.id].top,
                '--glow': glow,
                '--color': color,
              }}
            >
              {orderLabel !== null && (
                <div className="tower-order-badge">{orderLabel}</div>
              )}
              <div className="tower-circle" style={{ background: color, boxShadow: `0 0 14px 4px ${glow}` }}>
                <span className="tower-icon">
                  {type === TOWER_TYPES.FIRE && '🔥'}
                  {type === TOWER_TYPES.ICE && '❄️'}
                  {type === TOWER_TYPES.LIGHTNING && '⚡'}
                  {type === TOWER_TYPES.NEUTRAL && '🗿'}
                  {!type && tower.id}
                </span>
              </div>
              <div className="tower-id">T{tower.id}</div>
              <select
                className="tower-select"
                value={type}
                onChange={(e) => handleChange(tower.id, e.target.value)}
              >
                <option value="">-- Tipo --</option>
                {TYPE_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
          );
        })}
      </div>
    </div>
  );
}

